module.exports = __webpack_public_path__ + "static/media/ci_blue_edit.1e27b597.svg";